export default __webpack_public_path__ + "static/media/flight1.0543fa88.jpg";